export enum BrowserHistoryCommand {
  PUSH = "push",
  BACK = "back",
  FORWARD = "forward",
  REPLACE = "replace",
  CLOSE = "close"
}